import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Image, Form, Button, Spinner } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import axios from "axios";
import Cookies from "js-cookie";

function ManageMenu(props) {
  const MenuRouteId = useParams();
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [menuId, setMenuId] = useState(Number(MenuRouteId.MenuRouteId) || 0);
  const [menuDetails, setMenuDetails] = useState({
    MenuId: 0,
    MenuTitle: "",
    LanguageId: 1,
    DirectionId: 1,
    MenuOrder: 1,
    MetaTitle: "",
    MetaDescription: "",
    MetaKeyword: "",
    ImageUrl: "",
    ParentId: 0,
  });

  const [languages, setLanguages] = useState([]);
  const [directions, setDirections] = useState([]);

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [menuImageToDb, setMenuImageToDb] = useState("");
  const [menuImagePath, setMenuImagePath] = useState("");
  const [menuImage, setMenuImage] = useState("");
  const [menus, setMenus] = useState([]);

  // Get Menu Details
  const GetMenuDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "Menu/GetMenuDetails/" + menuId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    let result = await response.json();
    if (response.status === 200) {
      setMenuDetails(result);
    }
  };

  // Get Menus
  const GetMenus = async () => {
    let response = await fetch(
      Variables.API_URL + "Menu/GetMenusForDDL/" + menuId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    let result = await response.json();
    if (response.status === 200) {
      setMenus(result);
    }
  };

  // Get Languages
  const GetLanguages = async () => {
    let response = await fetch(Variables.API_URL + "Language/GetLanguages", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    let result = await response.json();
    if (response.status === 200) {
      setLanguages(result);
    }
  };

  // Get Directions
  const GetDirections = async () => {
    let response = await fetch(Variables.API_URL + "Direction/GetDirections", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    let result = await response.json();
    if (response.status === 200) {
      setDirections(result);
    }
  };

  // handle Inputs
  const handleInputs = (e) => {
    const { name, value } = e.target;
    var element;
    if (name != "ParentId") {
      if (value === "" || value === "0") {
        element = document.getElementById(name);
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById(name);
        element.classList.remove("is-invalid");
      }
    }

    setMenuDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Set Menu image
  const SetMenuImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setMenuImageToDb(x);
        setMenuImage(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("Image");
    element.classList.remove("is-invalid");
  };

  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (menuDetails.DirectionId === 0 || menuDetails.FirstName === "") {
      element = document.getElementById("DirectionId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (menuDetails.LanguageId === 0 || menuDetails.LanguageId === "") {
      element = document.getElementById("LanguageId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (menuDetails.MenuOrder === 0 || menuDetails.MenuOrder === "") {
      element = document.getElementById("MenuOrder");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (menuDetails.MenuTitle === null || menuDetails.MenuTitle === "") {
      element = document.getElementById("MenuTitle");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (menuId == 0) {
      if (menuImageToDb == "") {
        element = document.getElementById("Image");
        element.classList.add("is-invalid");
        hasError = true;
      }
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Menu
  const AddNewMenu = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Menu/AddNewMenu", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        MenuId: menuId,
        MenuTitle: menuDetails.MenuTitle,
        LanguageId: menuDetails.LanguageId,
        DirectionId: menuDetails.DirectionId,
        MenuOrder: menuDetails.MenuOrder,
        MetaTitle: menuDetails.MetaTitle,
        MetaDescription: menuDetails.MetaDescription,
        MetaKeyword: menuDetails.MetaKeyword,
        ParentId: menuDetails.ParentId,
        ImageUrl: ""
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      const formData2 = new FormData();
      formData2.append("Image", menuImageToDb);
      formData2.append("MenuId", result);

      const resImage = await axios.post(
        Variables.API_URL + "Menu/UploadMenuImage",
        formData2,{
          headers:{
            Authorization: `Bearer ${token}`,
          }
        }
      );

      toast.success("Menu Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Menu");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Update Menu
  const UpdateMenu = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Menu/UpdateMenu", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        MenuId: menuId,
        MenuTitle: menuDetails.MenuTitle,
        LanguageId: menuDetails.LanguageId,
        DirectionId: menuDetails.DirectionId,
        MenuOrder: menuDetails.MenuOrder,
        MetaTitle: menuDetails.MetaTitle,
        MetaDescription: menuDetails.MetaDescription,
        MetaKeyword: menuDetails.MetaKeyword,
        ParentId: menuDetails.ParentId,
        ImageUrl: ""
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      if (menuImageToDb != "") {
        const formData2 = new FormData();
        formData2.append("Image", menuImageToDb);
        formData2.append("MenuId", menuId);

        const resImage = await axios.post(
          Variables.API_URL + "Menu/UploadMenuImage",
          formData2,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
      }

      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Menu");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // handle submit
  const HandleSubmit = () => {
    var isValid = IsValid();
    if (isValid) {
      // case of insert
      if (menuId === 0) {
        AddNewMenu();
      }
      // case of update
      else {
        UpdateMenu();
      }
    } else {
      toast.error("Please fill all required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect( async () => {
    await GetLanguages();
    await GetDirections();
    await GetMenus();
    if (menuId != 0) {
      await GetMenuDetails();
    }
  }, []);

  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {menuId === 0 ? "New Menu" : "Update Menu"}
                </h4>
              </div>
            </Card.Header>
            {loader === true ? <CustomSnipper /> : ""}
            <Card.Body>
              <div className="new-user-info">
                <form>
                  <div className="row">
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Menu Title:</Form.Label>
                      <Form.Control
                        id="MenuTitle"
                        name="MenuTitle"
                        placeholder="Menu Name"
                        type="text"
                        value={menuDetails.MenuTitle}
                        onChange={handleInputs}
                      />
                    </Form.Group>
                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="email">Menu Order:</Form.Label>
                      <Form.Control
                        id="MenuOrder"
                        name="MenuOrder"
                        placeholder="Menu Order"
                        type="number"
                        value={menuDetails.MenuOrder}
                        onChange={handleInputs}
                      />
                    </Form.Group>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Menu :</Form.Label>
                      <select
                        className="form-control"
                        name="ParentId"
                        id="ParentId"
                        value={menuDetails.ParentId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select Parent Menu Section --
                        </option>
                        {menus.map((x) => {
                          return (
                            <option key={x.MenuId} value={x.MenuId}>
                              {x.MenuTitle}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group"></Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <div className="mb-3">
                        <Form.Label className="" htmlFor="customFile">
                          Image
                        </Form.Label>
                        <Form.Control
                          id="Image"
                          name="Image"
                          placeholder="Image"
                          type="file"
                          accept="image/*"
                          onChange={SetMenuImage}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      {menuImage !== "" ? (
                        <div>
                          <img
                            src={menuImage}
                            className="w-100 shadow-1-strong rounded mb-4 img-200 image-log"
                            alt="Boat on Calm Water"
                          />
                        </div>
                      ) : menuDetails.ImageUrl != "" ? (
                        <img
                          src={Variables.imagePath + menuDetails.ImageUrl}
                          className="w-100 shadow-1-strong rounded mb-4 img-200 image-log"
                          alt="Boat on Calm Water"
                        />
                      ) : null}
                    </Form.Group>

                    <Form.Group className="col-md-12 form-group">
                      <Form.Label htmlFor="fname">Meta Title:</Form.Label>
                      <textarea
                        className="form-control"
                        id="MetaTitle"
                        name="MetaTitle"
                        placeholder="Meta Title"
                        type="textarea"
                        value={menuDetails.MetaTitle}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>

                    <Form.Group className="col-md-12 form-group">
                      <Form.Label htmlFor="fname">Meta Description:</Form.Label>
                      <textarea
                        className="form-control"
                        id="MetaDescription"
                        name="MetaDescription"
                        placeholder="Meta Description"
                        type="textarea"
                        value={menuDetails.MetaDescription}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>

                    <Form.Group className="col-md-12 form-group">
                      <Form.Label htmlFor="fname">Meta Keyword :</Form.Label>
                      <textarea
                        className="form-control"
                        id="MetaKeyword"
                        name="MetaKeyword"
                        placeholder="Meta Keyword"
                        type="textarea"
                        value={menuDetails.MetaKeyword}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>
                  </div>
                </form>
              </div>
              <Row>
                <Col>
                  <Button
                    type="button"
                    variant="btn btn-primary"
                    className="float-right"
                    onClick={HandleSubmit}
                  >
                    {buttonLoader === true ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : menuId === 0 ? (
                      "Add New Menu"
                    ) : (
                      "Update Menu"
                    )}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ManageMenu;
